import React from 'react'
import { useFormContext } from 'react-hook-form'
import { FormField } from './FormField'

function evaluateCondition(actualValue, condition, expectedValue, negate) {
  let evaluated
  if (condition === 'equals') {
    if (Array.isArray(actualValue)) {
      if (Array.isArray(expectedValue)) {
        evaluated =
          expectedValue.length === actualValue.length &&
          expectedValue.every((x) => actualValue.includes(x))
      } else {
        evaluated = actualValue.length === 1 && actualValue[0] === expectedValue
      }
    } else {
      if (!actualValue) {
        //Wait for some value to be chosen
        return false
      }
      evaluated = actualValue === expectedValue
    }
  } else if (condition === 'contains') {
    evaluated = actualValue && actualValue.indexOf(expectedValue) !== -1
  } else if (condition === 'any') {
    evaluated = actualValue !== null && actualValue !== undefined
  }

  return negate ? !evaluated : evaluated
}

export function FormFieldConditional(props) {
  const { watch, getValues } = useFormContext()

  return (
    <div className="w-full">
      <div className="mt-6 text-left">
        {props.fields &&
          props.fields.map((field, i) => {
            return (
              <FormField
                key={`field-${i}`}
                name={field.fieldName}
                {...field}
                pageLocale={props.pageLocale}
                userLocation={props.userLocation}
                automationUser={props.automationUser}
                onSubmit={props.submit}
              />
            )
          })}

        {props.conditions &&
          props.conditions.map((x, i) => {
            const value = watch(x.fieldName)
            let expectedValue = x.value
            const isReplacementValue = x.value && x.value.match(/\{(.*)\}/)
            if (isReplacementValue && isReplacementValue.length === 2) {
              const values = getValues()
              const valuePropertyName = Object.getOwnPropertyNames(values).find((x) =>
                x.startsWith(isReplacementValue[1])
              )
              expectedValue = values[valuePropertyName]
            }

            if (evaluateCondition(value, x.condition, expectedValue, x.negate) && x.field) {
              return (
                <FormFieldConditional
                  key={`condition-${i}`}
                  {...x.field}
                  pageLocale={props.pageLocale}
                  userLocation={props.userLocation}
                  submit={props.submit}
                  automationUser={props.automationUser}
                />
              )
            }
          })}
      </div>
    </div>
  )
}
